module.exports = __webpack_public_path__ + "img/model_4.9632abf9.png";